const map = {
	"./Abu Dhabi 1.jpg": 7120,
	"./Al Mamzer Beach.jpg": 1047,
	"./Burj Khalifa.jpg": 5922,
	"./Dubai 2.jpg": 1196,
	"./Dubai Marina 1.jpg": 9559,
	"./Dubai Marina 3.jpg": 7893,
	"./Dubai.jpg": 7494,
	"./Kite Beach.jpg": 1225,
	"./La Mer Beach.jpg": 1117,
	"./Mosque.jpg": 1015
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3539;